import React from 'react';
import {
    isSucceeded,
    responseOrUndefined,
    useApiRequest,
} from '@givelify/utils';
import { useTranslation } from 'react-i18next';
import { LifeTimeData } from 'store/dashboard/lifeTime/types';
import { formatMoneyWithCommasAndDolarSign } from 'utils/formatMoneyWithCommas';
import { useDonationsActivityLoaderData } from '../../hooks/useDonationsActivityLoaderData';
import {
    Amount,
    Divider,
    Title,
    TotalDonationsSkeleton,
    TotalDonationsWrapper,
} from './styles';

const TotalDonationsComponent: React.FCC = () => {
    const { t } = useTranslation();
    const copy = React.useMemo(
        () => ({
            title: t('donationsActivity.text.totalDonations'),
        }),
        [t],
    );

    const { totalDonationsData } = useDonationsActivityLoaderData();

    const [getDonationsStatisticRequest] =
        useApiRequest<LifeTimeData>(totalDonationsData);

    const donationStatistic = responseOrUndefined(getDonationsStatisticRequest);
    const isDonationStatisticSucceeded = isSucceeded(
        getDonationsStatisticRequest,
    );

    return isDonationStatisticSucceeded ? (
        <TotalDonationsWrapper data-testid="total-donations-wrapper">
            <Title
                data-testid="total-donations-text"
                text={copy.title}
                variant="body2"
            />
            <Divider />
            <Amount
                data-testid="total-donations-amount"
                text={formatMoneyWithCommasAndDolarSign(
                    donationStatistic?.data?.sum,
                )}
                variant="heading3M"
            />
        </TotalDonationsWrapper>
    ) : (
        <TotalDonationsSkeleton
            data-testid="total-donations-skeleton"
            variant="rectangular"
        />
    );
};

export const TotalDonations = React.memo(TotalDonationsComponent);
